import { Fragment, HTMLAttributes, forwardRef } from 'react';

import {
  Divider,
  Theme,
  WithStyles,
  createStyles,
  styled,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

import { useComments } from '@spotify/plugin-confidence-comments-react';

import { Thread } from './Thread';
import { useActivityFeedItemContext } from './context';

const StyledDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(4, 0),
}));

const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(1.5),
    },
    empty: {
      fontStyle: 'italic',
    },
    replyContainer: {
      marginLeft: theme.spacing(6),
      marginTop: theme.spacing(4),
    },
  });

export interface CommentListProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'classes'>,
    WithStyles<typeof styles> {}

const CommentList = forwardRef<HTMLDivElement, CommentListProps>(
  (props, ref) => {
    const { className, classes, ...rest } = props;
    const { activity } = useActivityFeedItemContext();

    const { comments } = useComments({ resource: activity.name });

    return (
      <div ref={ref} className={classNames(classes.root, className)} {...rest}>
        {comments?.map(comment => (
          <Fragment key={comment.name}>
            <Thread comment={comment} />
            <StyledDivider />
          </Fragment>
        ))}
      </div>
    );
  },
);

CommentList.displayName = 'ActivityFeedItem.CommentList';

export default withStyles(styles)(CommentList);
